const Style = {
    container: 'flex w-full mx-auto overflow-x-auto',
};

export default Style;